import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../utils/apiBase';

const ThemeProvider = ({ children }) => {
  const [themeLoaded, setThemeLoaded] = useState(false);

  useEffect(() => {
    fetchTheme();
  }, []);

  const fetchTheme = async () => {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 3500);
    try {
      const response = await fetch(`${API_BASE_URL}/event-config`, { signal: ctrl.signal });
      const data = await response.json();
      
      if (data.theme) {
        // Apply theme colors as CSS custom properties
        const root = document.documentElement;
        if (data.theme.primaryColor) {
          root.style.setProperty('--theme-primary', data.theme.primaryColor);
        }
        if (data.theme.secondaryColor) {
          root.style.setProperty('--theme-secondary', data.theme.secondaryColor);
        }
        if (data.theme.backgroundColor) {
          root.style.setProperty('--theme-background', data.theme.backgroundColor);
        }
      }
    } catch (error) {
      console.error('Error fetching theme:', error);
      // Use default theme colors
      const root = document.documentElement;
      root.style.setProperty('--theme-primary', '#007bff');
      root.style.setProperty('--theme-secondary', '#6c757d');
      root.style.setProperty('--theme-background', '#0d6efd');
    } finally {
      clearTimeout(timer);
      setThemeLoaded(true);
    }
  };

  if (!themeLoaded) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        color: 'white',
        fontSize: '1.2rem'
      }}>
        Loading theme...
      </div>
    );
  }

  return <>{children}</>;
};

export default ThemeProvider;
